<div bsModal #smModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body">
                    <div class="checkMark">
                        &#10004;
                    </div>
                    <p class="title">
                        Success
                    </p>
                    <p class="message">
                        {{successMessage}}
                    </p>
                    <button class="btn btn-active" (click)="hide()">OK</button>
            </div>
        </div>
    </div>
</div>